/**
 * Apply "not" operator to the input.
 */
export function negate(value: any): boolean {
  return !value;
}
